export const stateName = 'businessAccounts';
export const REGISTRATION_FORM_STORAGE_KEY = 'business_registration_form';
export let BusinessDetailsField;

(function (BusinessDetailsField) {
  BusinessDetailsField["LegalCode"] = "businessDetails.legalCode";
  BusinessDetailsField["LegalName"] = "businessDetails.legalName";
  BusinessDetailsField["EntityType"] = "businessDetails.entityType";
  BusinessDetailsField["Vat"] = "businessDetails.vat";
  BusinessDetailsField["IsVatDisabled"] = "businessDetails.isVatDisabled";
})(BusinessDetailsField || (BusinessDetailsField = {}));

export let KybFieldName;

(function (KybFieldName) {
  KybFieldName["IdentityDocument"] = "identity_document";
  KybFieldName["Ubos"] = "ubos";
})(KybFieldName || (KybFieldName = {}));